module.exports = __webpack_public_path__ + "static/media/rhodes_0036_rust.6d355920.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rhodes_0036_rust.jpg
// module id = 188
// module chunks = 0